import { Swiper } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import { CommonSwiperProps } from '@/types/common';

export default function CommonSwiper({
  children,
  ...props
}: CommonSwiperProps) {
  return (
    <Swiper
      slidesPerView={1}
      autoplay={{
        delay: 5000,
      }}
      loop={true}
      spaceBetween={50}
      modules={[Autoplay]}
      {...props}
    >
      {children}
    </Swiper>
  );
}
